<template>
  <div>
    <v-tabs
      v-model="selectedTab"
      fixed-tabs
      height="80px"
      background-color="transparent"
      show-arrows
      :slider-color="activeSliderColor ? 'primary' : 'transparent'"
      :color="activeSliderColor ? 'primary' : 'rgba(0, 0, 0, 0.54)'"
    >
      <v-tab
        id="tab-historico"
        @click="
          changeTipoListaConsulta('historico');
          goToFirstPage();
          notifyClickEvent();
        "
      >
        <span>
          <div>
            <v-icon class="icon-tab mb-2">mdi-history</v-icon>
          </div>
          Historico
        </span>
      </v-tab>

      <v-tab
        id="tab-favoritos"
        @click="
          changeTipoListaConsulta('favoritos');
          notifyClickEvent();
        "
      >
        <span>
          <div>
            <v-icon class="icon-tab mb-2">mdi-star</v-icon>
          </div>
          Favoritos
        </span>
      </v-tab>

      <v-menu v-if="regulatoriasList" transition="slide-y-transition" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-tab id="tab-tabelas-regulatorias" v-bind="attrs" v-on="on" @click="notifyClickEvent()">
            <span>
              <div>
                <v-icon class="icon-tab mb-2 mt-4">mdi-gavel</v-icon>
              </div>
              Tabelas Regulatórias
            </span>
          </v-tab>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in regulatoriasList.children" :key="index" @click="checkRelatorioFixo(item)">
            {{ item.title }}
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-model="tabPrincipal" transition="slide-y-transition" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-tab id="tab-modelos" v-bind="attrs" v-on="on" @click="notifyClickEvent()">
            <span>
              <div>
                <v-icon class="icon-tab mb-2">mdi-file-cog-outline</v-icon>
              </div>
              Modelos
            </span>
          </v-tab>
        </template>
        <v-list>
          <v-list-item v-for="(grupo, index) in modelosList" :key="index">
            <v-menu open-on-hover transition="slide-x-transition" offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-title v-bind="attrs" v-on="on">
                  {{ grupo.title }}
                  <v-icon>mdi-menu-right</v-icon>
                </v-list-item-title>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, itemIndex) in grupo.children"
                  :key="itemIndex"
                  @click="(checkRelatorioFixo(item), (tabPrincipal = !tabPrincipal))"
                >
                  {{ item.title }}
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-tabs>
  </div>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService.js';

  export default {
    name: 'RelatoriosNavigationDrawer',

    components: {},

    props: {
      relatoriosModelos: {
        type: Array,
        default: () => []
      },
      activeSliderColor: {
        type: Boolean,
        default: true
      }
    },

    emits: ['actionVisualizarTriggered', 'goToFirstPage', 'click:triggered'],

    data() {
      return {
        selectedTab: 0,
        tabelasRegulatorias: [],
        tabPrincipal: false
      };
    },

    computed: {
      modelosList: function () {
        return this.relatoriosModelos.filter(
          (element) =>
            element.title != 'Tabelas Regulatórias' && element.title != 'BRR Report' && element.title != 'Estatísticas do Sistema'
        );
      },

      regulatoriasList: function () {
        const aux = this.relatoriosModelos.filter((element) => element.title == 'Tabelas Regulatórias');
        return aux[0];
      },

      modelosMenu: function () {
        let array = [];
        this.modelosChildren.forEach((element) => {
          array.push({
            id: element.id,
            title: element.title
          });
        });
        return array;
      },

      modelosSubMenu() {
        let array = [];
        this.modelosChildren.forEach((element) => {
          element.children.forEach((element2) => {
            array[element.id].push({
              id: element2.id,
              title: element2.title
            });
          });
        });
        return array;
      },

      tipoListaConsulta() {
        return this.$store.getters.getTipoListaConsulta;
      }
    },

    methods: {
      changeTipoListaConsulta(tipo) {
        if (tipo) {
          this.$store.dispatch('setTipolistaConsulta', tipo);
        }
        return;
      },
      checkRelatorioFixo(item) {
        RelatoriosService.getLastConsultaFilhaByModeloId(item.id)
          .then((res) => {
            switch (res.data.relatorio_fixo) {
              case true:
                if (res.data.consulta_id != null) {
                  this.$emit('actionVisualizarTriggered', { ativo: true, relatorio_id: res.data.consulta_id });
                } else {
                  const msg = `Não há nenhum relatório '${item.title}' cadastrado no Sistema.<br>Por favor, crie seu relatório e aguarde sua execução.`;
                  this.$router.push(`modelo/${item.id}`);
                  this.$toast.info(msg, '', { position: 'topRight', timeout: 6000 });
                }
                break;
              default:
                this.changeTipoListaConsulta(item.id);
                break;
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast.error('Erro ao encontrar relatório.', '', { position: 'topRight' });
          });
      },
      goToFirstPage() {
        this.$emit('goToFirstPage');
      },
      notifyClickEvent() {
        this.$emit('click:triggered');
      },
      getSelectedTab() {
        let codigo = this.$store.getters.getTipoListaConsulta;
        let checkRegulatoria = this.regulatoriasList?.children?.some((el) => el.id == codigo) ?? false;

        switch (codigo) {
          case '':
          case 'historico':
            return 0;
          case 'favoritos':
            return 1;
          default:
            if (checkRegulatoria) {
              return 2;
            } else {
              return 3;
            }
        }
      }
    },

    watch: {
      relatoriosModelos() {
        this.selectedTab = this.getSelectedTab();
      },

      tipoListaConsulta() {
        this.selectedTab = this.getSelectedTab();
      }
    }
  };
</script>

<style>
  .icon-tab {
    margin-bottom: 15px !important;
  }
</style>
